import {
  IconArrowLeft,
  IconArrowRight,
  IconChevronLeft,
  IconChevronRight,
} from "@tabler/icons-react";
import { ComponentProps } from "react";
import { useDocumentDirection } from "@app/hooks";

type ArrowIconProps = ComponentProps<typeof IconArrowLeft>;

export function BackIcon(props: ArrowIconProps) {
  const direction = useDocumentDirection();
  const Icon = direction === "rtl" ? IconArrowRight : IconArrowLeft;

  return <Icon {...props} />;
}

export function ForwardIcon(props: ArrowIconProps) {
  const direction = useDocumentDirection();
  const Icon = direction === "rtl" ? IconArrowLeft : IconArrowRight;

  return <Icon {...props} />;
}

export function BackChevronIcon(props: ArrowIconProps) {
  const direction = useDocumentDirection();
  const Icon = direction === "rtl" ? IconChevronRight : IconChevronLeft;

  return <Icon {...props} />;
}

export function ForwardChevronIcon(props: ArrowIconProps) {
  const direction = useDocumentDirection();
  const Icon = direction === "rtl" ? IconChevronLeft : IconChevronRight;

  return <Icon {...props} />;
}
